module.exports = __webpack_public_path__ + "static/media/help.ba61083e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/components/Icon/help.svg
// module id = 6792
// module chunks = 0